import React from 'react'
import style from "./input.module.css"

export const Input = ({ label, error = false, ...props }) => {
    return (
        <div className={style.input_container}>
            {label && <label className={"label"}>{label}</label>}
            <input  {...props} className={`${style.input} ${error && "error_input"} ${props.className}`} />
        </div>
    )
}